import { useQuery } from "@tanstack/react-query";
import { queryClient } from "shared/api/queryClient";
import { getActiveModuleTemplateList } from "../api/getActiveModuleTemplateList";

const getQueryKey = (brandId?: string, gamesOnly?: boolean) =>
  ["activeModuleTemplates", brandId, gamesOnly].filter(Boolean);

export const useActiveModuleTemplateListQuery = (
  brandId?: string,
  gamesOnly?: boolean,
) => {
  return useQuery({
    queryKey: getQueryKey(brandId, gamesOnly),
    queryFn: async () => {
      return getActiveModuleTemplateList(brandId, gamesOnly);
    },
  });
};

export const invalidateActiveModuleTemplateListQuery = async (
  brandId?: string,
  gamesOnly?: boolean,
) => {
  await queryClient.invalidateQueries({
    queryKey: getQueryKey(brandId, gamesOnly),
  });
};
